/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSubjectAgentsResponse } from '../../models/get-subject-agents-response';

export interface GetApiSubjectV1IdAgents$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiSubjectV1IdAgents$Json(http: HttpClient, rootUrl: string, params: GetApiSubjectV1IdAgents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectAgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiSubjectV1IdAgents$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSubjectAgentsResponse>;
    })
  );
}

getApiSubjectV1IdAgents$Json.PATH = '/private/v1/subjects/{id}/agents';
